var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeCard1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84.47 74.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:3px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.78,
    y: 26.44,
    width: 34.03,
    height: 24.52,
    rx: 1.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 51.7,
    y: 36.1,
    width: 21.12,
    height: 15.22,
    rx: 1.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.89,
    y: 9.81,
    width: 16,
    height: 9.86,
    rx: 1.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.42,
    y: 1.5,
    width: 10.47,
    height: 18.17,
    rx: 1.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.55,73.3H8.93a7.43,7.43,0,0,1,0-14.86H75.55a7.43,7.43,0,0,1,0,14.86Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.89,
    cy: 65.9,
    r: 2.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 75.88,
    cy: 65.9,
    r: 2.58
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCard1);
export default __webpack_public_path__ + "static/media/homeCard1.efa4b2b44b77cd20541340962e0484a0.svg";
export { ForwardRef as ReactComponent };